<template>
  <el-popover
    placement="top"
    width="190"
    trigger="click"
    v-model="showRepeatPopover">
    <div v-if="showRepeatPopover" class="d-flex">
      <el-input-number v-model="repeat" type="number" size="mini" :min="0" style="width: 65%" class="mr-2" />
      <el-button size="mini" @click="onSetDuration()">ok</el-button>
    </div>
    <span slot="reference" v-if="repeat !== undefined" class="repeat-quick-settings-text" >
      <slot v-bind:repeat="repeat" v-bind:value="value">
        {{ value }}&nbsp;×
      </slot>
    </span>
  </el-popover>
</template>

<script>
export default {
  props: {
    value: {
      type: Number
    },
    updateOnSave: {
      default: true
    },
  },
  data: () => ({
    repeat: 0,
    showRepeatPopover: false,
  }),
  created() {
    this.repeat = isNaN(this.value) ? 0 : this.value;
  },
  watch: {
    value(value) {
      this.repeat = this.value;
    },
    repeat(value) {
      if ( !this.updateOnSave ) {
        this.$emit('input', value);
      }
    },
  },
  methods: {
    onSetDuration() {
      let repeat = ( this.repeat >= 0 ) ? this.repeat : 0;

      if ( this.updateOnSave ) {
        this.$emit('input', repeat);
      }

      this.showRepeatPopover = false;
      this.$emit('save', repeat);
      this.repeat = repeat;
    },
  }
}
</script>

<style>
.repeat-quick-settings-text:hover {
  text-decoration: underline;
  text-decoration-style: double;
  text-decoration-color: #409eff;
}
.repeat-quick-settings-text {
  cursor: pointer;
}
</style>
